import * as ng from 'angular';

import {WeatherApiService} from './weather-api.service';

const templateUrl = require('./weather.directive.html');

ng.module('e360')
   .directive('weather', weatherDirective);

export function weatherDirective():ng.IDirective {
   return {
      restrict: 'A',
      scope: {
         event: '='
      },
      templateUrl: templateUrl,
      controller: WeatherDirectiveController,
      controllerAs: 'vm',
      link: weatherDirectiveLinkFn
   };

   function weatherDirectiveLinkFn(scope, element, attrs) {
      let eventWatcher = scope.$watch('event', function (event) {
         if (event) {
            scope.vm.eventChanged(event);
         }
      });

      let destroyWatcher = scope.$on('destroy', function () {
         eventWatcher();
         destroyWatcher();
      });
   }
}

class WeatherDirectiveController {
   static $inject = ['weatherApi', 'utils'];

   private _days:any[];
   private _dayIndex = -1;
   private _location:string;

   weather:any;

   constructor(private weatherApi:WeatherApiService, private utils) { }

   get selectedDay():any {
      if (this._days && this._days.length > 0) {
         return this._days[this._dayIndex];
      } else {
         return null;
      }
   }

   get hasPreviousDay():boolean {
      return this._days && this._dayIndex > 0;
   }

   get hasNextDay():boolean {
      return this._days && this._dayIndex < (this._days.length - 1);
   }

   get title():string {
      if (this.selectedDay) {
         return this.utils.formatDate(this.selectedDay);
      }

      return '';
   }

   previous() {
      if (this._dayIndex > 0) {
         this._dayIndex--;
         this.load();
      }
   };

   next() {
      if (this._dayIndex < (this._days.length - 1)) {
         this._dayIndex++;
         this.load();
      }
   }

   eventChanged(event) {
      this._days = this.utils.allDaysBetween(event.startDateTime, event.endDateTime);

      this._location = null;
      if (event.lat && event.lng) {
         // previously the location query used "[CityName],[StateCode]"
         // according to weather service API that query format only works for US
         // (appears to work fine with CA too)
         // event city can now be null for virtual events, so a more reliable
         // query format is "[latitude],[longitude]" since event form fills
         // lat,lng for virtual events too
         // HOWEVER event details panel is initially set without lat/lng
         // then event object is updated via async request, so weather is
         // briefly unloaded when details panel is shown
         this._location = [event.lat, event.lng].join(',');
      }

      if (this._days.length > 0) {
         this._dayIndex = 0;
         this.load();
      }
   }

   private load() {
      let onResult = (data) => {
         this.weather = data;
      };

      if (this._location) {
         this.weatherApi.get(this._location, this.selectedDay).then(onResult, onResult);
      } else {
         this.weather = { error: true };
      }
   }
}
